import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { Brightness4, Brightness7 } from '@mui/icons-material';
import { useTheme } from '../contexts/ThemeContext';

interface ThemeToggleProps {
    size?: 'small' | 'medium' | 'large';
    color?: 'inherit' | 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';
}

const ThemeToggle: React.FC<ThemeToggleProps> = ({ 
    size = 'medium', 
    color = 'inherit' 
}) => {
    const { mode, toggleTheme } = useTheme();

    return (
        <Tooltip title={`Switch to ${mode === 'dark' ? 'light' : 'dark'} mode`}>
            <IconButton
                onClick={toggleTheme}
                color={color}
                size={size}
                sx={{
                    transition: 'all 0.3s ease',
                    '&:hover': {
                        transform: 'rotate(180deg)',
                    },
                }}
            >
                {mode === 'dark' ? <Brightness7 /> : <Brightness4 />}
            </IconButton>
        </Tooltip>
    );
};

export default ThemeToggle; 